import { TFunction } from 'i18next';

export function formatPrice(t: TFunction<'translation', undefined>, price?: number) {
  if (!price || price <= 0) {
    return t('freePriceText');
  }
  var localPrice = price!.toLocaleString('de-DE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
  return t('fullPriceText', { priceTerm: localPrice });
}

export function formatPriceForAdditionalService(
  t: TFunction<'translation', undefined>,
  price?: number
) {
  const prefix = !price || price <= 0 ? '' : '+ ';
  const priceText = formatPrice(t, price);
  return prefix + priceText;
}
